import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent {
  /**
   * Optional text message to show under the spinner.
   */
  @Input() message?: string;

  /**
   * If true, a minimum height is applied so the overlay provides vertical space.
   */
  @Input() fullHeight: boolean = true;

  /**
   * When true, overlay styling becomes absolute with blur (useful for covering content).
   */
  @Input() overlay: boolean = false;
}


